export const GET_SIGNIN_REQUEST = "GET_SIGNIN_REQUEST";
export const GET_SIGNIN_SUCCESS = "GET_SIGNIN_SUCCESS";
export const GET_SIGNIN_FAILURE = "GET_SIGNIN_FAILURE";

export const GET_SOCIAL_LOGIN = "GET_SOCIAL_LOGIN"

export const SET_SOCIAL_LOGIN = "SET_SOCIAL_LOGIN"